module.exports = __webpack_public_path__ + "static/media/img4-2.fa92eca7.png";